import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from './ui/button';

const PaymentFailure = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-red-50 to-orange-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-2xl p-8 text-center">
        <div className="mb-6">
          <XCircle className="w-20 h-20 text-red-500 mx-auto" />
        </div>
        
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          Payment Failed
        </h1>
        
        <p className="text-gray-600 mb-6">
          Unfortunately, your payment could not be processed. No charges have been made to your account.
        </p>

        <div className="bg-red-50 rounded-lg p-4 mb-6">
          <p className="text-sm text-gray-700">
            Common reasons for payment failure:
          </p>
          <ul className="text-left text-sm text-gray-700 mt-2 space-y-1 ml-4">
            <li>• Insufficient funds</li>
            <li>• Incorrect card details</li>
            <li>• Bank declined the transaction</li>
            <li>• Payment timeout</li>
          </ul>
        </div>

        <p className="text-sm text-gray-600 mb-6">
          Would you like to try again or contact us for assistance?
        </p>

        <div className="space-y-3">
          <Button
            onClick={() => navigate('/#contact')}
            className="w-full bg-[#6B0B0B] hover:bg-[#8B1515] text-white py-6 text-lg font-semibold"
          >
            Try Again
          </Button>
          
          <Button
            onClick={() => navigate('/')}
            variant="outline"
            className="w-full border-[#6B0B0B] text-[#6B0B0B] hover:bg-[#6B0B0B] hover:text-white py-6 text-lg"
          >
            Return to Home
          </Button>

          <a 
            href="tel:062 681 4586"
            className="block text-sm text-[#6B0B0B] hover:underline mt-4"
          >
            Or call us: 062 681 4586
          </a>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailure;
